// extracted by mini-css-extract-plugin
export default {"page":"thankyou_page__0DsVP","textWrapper":"thankyou_textWrapper__Dlh+g","button":"thankyou_button__whrHx"};